export default "__VITE_ASSET__82eb8239__"